

export const getPropertyLocation = (loc: string) => (
    loc.split(",").map(item => +item)
)